// eslint-disable-next-line no-unused-vars
import React, { useCallback, useEffect, useMemo } from 'react'
import { gql, useLazyQuery } from '@apollo/client'
import { useAuth } from '@nobia/zeus-components/lib/auth'

const allStoresQuery = gql`
  query stores($includeFakeStores: Boolean) {
    store {
      id
      stores(includeFakeStores: $includeFakeStores) {
        id
        storeName
        storeManagerId
      }
    }
  }
`

export const useStores = () => {
  const { profile } = useAuth()

  const [fetch, { loading, data }] = useLazyQuery(allStoresQuery, {
    variables: {
      includeFakeStores: Array.isArray(profile?.roles)
        ? !!profile?.roles.find(r => r === 'fake-stores')
        : profile?.roles === 'fake-stores',
    },
  })

  const sortByName = useCallback((a, b) => {
    if (a.id < 0 || b.id < 0) {
      if (a.id < 0 && b.id < 0) {
        return a.id > b.id ? -1 : 1
      }
      return a.id > b.id ? 1 : -1
    }
    const compare = a.storeName.localeCompare(b.storeName)
    if (compare > 0) {
      return 1
    } else if (compare < 0) {
      return -1
    }

    return 0
  }, [])

  const sortedStores = useMemo(
    () => [...(data?.store?.stores || [])].sort(sortByName),
    [data, sortByName]
  )

  useEffect(() => {
    if (profile?.roles?.includes('staff')) {
      fetch()
    }
  }, [fetch, profile?.roles])

  return { loading, stores: sortedStores }
}
